import React from 'react';
import HelpSupportForm from './HelpSupportForm';
import HelpRosterPanel from './HelpRosterPanel';
import HelpAvailabilityPanel from './HelpAvailabilityPanel';
import HelpInjuryPeriodPanel from './HelpInjuryPeriodPanel';
import HelpHolidayPeriodPanel from './HelpHolidayPeriodPanel';
import HelpSeasonForfeitPanel from './HelpSeasonForfeitPanel';
import HelpSelfLeaveTeamPanel from './HelpSelfLeaveTeamPanel';
import HelpFindTeammatePanel from './HelpFindTeammatePanel';
import HelpFindPlayersPanel from './HelpFindPlayersPanel';
import HelpInvitePlayerPanel from './HelpInvitePlayerPanel';
import HelpMatchSchedulePanel from './HelpMatchSchedulePanel';
import HelpOpponentContactPanel from './HelpOpponentContactPanel';
import HelpCourtBookingPanel from './HelpCourtBookingPanel';
import HelpPartnerClubsPanel from './HelpPartnerClubsPanel';

const WIDGETS = {
  support_form: HelpSupportForm,
  roster_manage: HelpRosterPanel,
  availability: HelpAvailabilityPanel,
  injury_period: HelpInjuryPeriodPanel,
  holiday_period: HelpHolidayPeriodPanel,
  season_forfeit: HelpSeasonForfeitPanel,
  self_leave_team: HelpSelfLeaveTeamPanel,
  find_teammate: HelpFindTeammatePanel,
  find_players: HelpFindPlayersPanel,
  invite_player: HelpInvitePlayerPanel,
  match_schedule: HelpMatchSchedulePanel,
  opponent_contact: HelpOpponentContactPanel,
  court_booking: HelpCourtBookingPanel,
  partner_clubs: HelpPartnerClubsPanel,
};

/**
 * @param {object} props
 * @param {string} props.widget
 * @param {string} props.nodeId
 * @param {object} [props.node]
 * @param {object|null} [props.teamContext]
 * @param {object|null} [props.match]
 */
export default function HelpInlineWidget({ widget, nodeId, node, teamContext, match }) {
  const Component = WIDGETS[widget];
  if (!Component) return null;

  if (widget === 'support_form') {
    return (
      <Component
        nodeId={nodeId}
        supportPreset={node?.supportPreset}
        teamContext={teamContext}
        match={match}
      />
    );
  }

  if (
    widget === 'find_teammate' ||
    widget === 'find_players' ||
    widget === 'availability' ||
    widget === 'injury_period' ||
    widget === 'holiday_period' ||
    widget === 'partner_clubs' ||
    widget === 'court_booking'
  ) {
    return <Component />;
  }

  if (widget === 'invite_player') {
    return <Component teamContext={teamContext} />;
  }

  if (widget === 'season_forfeit' || widget === 'self_leave_team') {
    return <Component teamContext={teamContext} />;
  }

  return <Component teamContext={teamContext} match={match} nodeId={nodeId} node={node} />;
}

export { WIDGETS };
